<template>
  <div>
    <div
      id="dash-app"
      :ref="`embedContainer_${plotlyUID}`"
      :key="plotlyUID"
    ></div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'AscPlotly',

  props: {
    plotlyData: {
      type: Object,
      default: null,
    },
    reRender: {
      type: Boolean,
      default: false,
    },
    isDirty: {
      type: Boolean,
      default: false,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    chronicRepeatersData: {
      type: Object,
      default: undefined,
    },
    lookBackRunInfo: {
      type: Object,
      default: undefined,
    },
    isRender: {
      type: Boolean,
      default: false,
    },
    globalFilterAirlines: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      plotlyUID: uuidv4(),
    }
  },

  watch: {
    plotlyData(newValue) {
      if (this.plotlyData) {
        this.$nextTick(() => {
          this.updatePlotlyToken(newValue)
        })
      }
    },

    reRender(newValue) {
      if ((newValue || this.isRender) && this.isDirty) {
        this.plotlyUID = uuidv4()
        this.$nextTick(() => {
          this.updatePlotlyToken(this.plotlyData)
        })
      }
    },
  },

  methods: {
    updatePlotlyToken(data) {
      // invoke a function from the official Dash library to do the embedding
      // using the url of a target Dash app and a suitable embed token
      const callback = {
        relatedEventsUpdate: (selections, event) => {
          if (this.isReadonly) return

          const selectionArray = selections ? Object.values(selections) : []

          const eventMap = {
            USER: 'onRelatedEventGridChange',
            NEW_ISSUE: 'onIssueCreation',
            APPLY_SELECTIONS: 'onRepeaterRelatedEventGridChange',
          }

          const emitEvent = eventMap[event]
          if (emitEvent) {
            this.$emit(emitEvent, {
              relatedEventsGridSelections: selectionArray,
            })
          }
        },
      }

      window.dash_embedded_component.renderDash(
        {
          url_base_pathname: data.url,
          auth_token: data.token,
        },
        this.$refs[`embedContainer_${this.plotlyUID}`],
        {
          callback,
          readOnly: this.isReadonly,
          ChronicRepeaters: this.chronicRepeatersData,
          CustomAnalyticLookback: this.lookBackRunInfo,
          MaintenanceData: this.globalFilterAirlines,
        },
      )
    },
  },
}
</script>
